import { useState, useRef, useEffect } from 'react';
import styles from './style.module.css';
import Checkbox from '../Checkbox';
import Portal from '../../utils/Portal';

export default function Table({
    className=null,
    title=null, 
    cellWidth=null,
    header, 
    row,
    checkbox = false,
    resetCheck=false,
    onCheckChange=()=>{},
    modalColNum=[],
    onClickModal,
    toggleColNum = [],
    rowMenu=false,
    rowHover=false,
    state='loaded',
    readyView=<div>Ready</div>,
    emptyView=<div>Empty</div>,
}) {
    const columns = checkbox ? header.length+1 : header.length;
    const gridStyle = {
        gridTemplateColumns: 
            cellWidth?`${cellWidth}`
            :
            checkbox?
            `84px repeat(${columns-1}, 1fr)`
            :
            `repeat(${columns}, 1fr)`
    };
    const [toggleValues, setToggleValues] = useState([]);
    const [checkValues, setCheckValues] = useState([]);
    const [pos,setPos]=useState({x:0,y:0})
    const [isRowMenu,setIsRowMenu]=useState(-1);
    const rowMenuRef=useRef(null);

    const handleToggleChange = (rowIndex, colIndex) => {
        const newValues = [...toggleValues];
        newValues[rowIndex][colIndex] = !newValues[rowIndex][colIndex];
        setToggleValues(newValues);
    };

    const handleCheckChange = (rowIndex) => {
        const newValues = [...checkValues];
        newValues[rowIndex] = !newValues[rowIndex];
        setCheckValues(newValues);
    };

    const handleClickRow=(e,rowIndex)=>{
        e.stopPropagation();
        setPos({
            x:e.clientX,
            y:e.clientY
        })

        setIsRowMenu(rowIndex)
    }

    useEffect(()=>{
        if(checkValues.length===0){
            setCheckValues(row.map(rowData => false));
        }

        if(toggleColNum.length>0){
            setToggleValues(row.map(rowData => rowData.map(() => false)));
        }
    },[row])

    useEffect(()=>{
        if(isRowMenu!=-1){
            document.addEventListener('mousedown',handleOutsideClick);
        }else{
            document.removeEventListener('mousedown',handleOutsideClick);
        }

        return()=>{
            document.removeEventListener('mousedown',handleOutsideClick);
        }
    },[isRowMenu])

    useEffect(()=>{
        const checkedIdx=checkValues
        .map((val,idx)=>(val?idx:null))
        .filter(idx=>idx!==null)
        onCheckChange(checkedIdx)
    },[checkValues])

    useEffect(()=>{
        setCheckValues(row.map(rowData => false));
    },[resetCheck])

    const handleOutsideClick=(e)=>{
        if(rowMenuRef.current && !rowMenuRef.current.contains(e.target)){
            setIsRowMenu(-1);
        }
    }

    return (
        <div className={`${styles['wrap']} ${className}`}>
            {title&&<span className={styles['header']}>{title}</span>}
            <div className={styles['header-row']} style={gridStyle}>
                {checkbox&&<Checkbox 
                    isChecked={checkValues.length>0 && checkValues.every(value => value)} 
                    onChange={() => {
                        const newValue = !checkValues.every(value => value);
                        setCheckValues(checkValues.map(() => newValue));
                    }}
                />}
                {header.map((item) => (
                    (typeof item!=='object'?
                    <span className={styles['cell']}>{item}</span>
                    :
                    <div className={styles['header-group']}>
                        {item.title}
                        <div className={styles['header-sub']}
                        style={{gridTemplateColumns: `repeat(${item.subTitle.length}, 1fr)`}}>
                        {item.subTitle.map((subItem) => (
                            <span className={styles['cell']}>{subItem}</span>
                        ))}
                        </div>
                    </div>
                    )
                ))}
            </div>
            {
            state===null?
            readyView
            :
            state==='empty'?
            emptyView
            :
            state==='loading'?
            Array.from({length:8},(_,i)=><>
            <div key={i} className={styles['skeleton-row']} style={{...gridStyle,opacity:1-i/7}}>
                {checkbox&&<div/>}
                {header.map(() => (
                    <div/>
                ))} 
            </div>
            </>)
            :
            row.map((rowData, rowIndex) => (
            <div key={rowIndex} 
            className={`
                ${styles['row']} 
                ${rowHover&&styles['row-hover']} 
                ${rowMenu&&styles['row-cursor']} 
                ${isRowMenu===rowIndex&&styles['row-hover-keep']}`
            } 
            style={gridStyle}
            onClick={(e)=>rowMenu&&handleClickRow(e,rowIndex)}
            >
                {checkbox && <Checkbox 
                    isChecked={checkValues[rowIndex]} 
                    onChange={()=>handleCheckChange(rowIndex)}
                />}
                {rowData.map((item, colIndex) => (
                    <span key={colIndex} className={styles['cell']}>
                        {
                            item
                        }
                    </span>
                ))}
            {isRowMenu!=-1 && (
            <Portal>
                <div
                ref={rowMenuRef}
                className={styles['row-menu']}
                style={{
                    top:pos.y, 
                    left:pos.x,
                    position:'absolute'
                }}>
                    <span onClick={(e)=>{
                        e.stopPropagation();
                    }}>Detail</span>
                    <span onClick={(e) => {
                        e.stopPropagation();
                        handleCheckChange(isRowMenu);
                    }}>Check</span>
                </div>
            </Portal>)}
            </div>
            ))}
        </div>
    )       
}